import React from 'react';

import type {extractProps} from '@famly/mf_ts-utils_extract-props';

import {extractAriaProps} from './extract-aria-props';

/**
 * Utility hook to extract all aria-attributes that are added to components
 */
export const useAriaProps = <P extends Dictionary<string, any>>(
    props: P,
): ReturnType<typeof extractProps<P, 'aria'>> => {
    return React.useMemo(() => {
        return extractAriaProps<P>(props);
    }, [props]);
};
